<script>
import { mapState, mapActions } from 'vuex';
import TwTitleBar from '../../components/TwTitleBar';

export default {
  name: 'TransportationWrapper',
  components: {
    TwTitleBar,
  },
  data() {
    return {
      activeTab: '',
      tabs: [
        { id: 1, name: 'Routes', route: '/transportation/overview/routes' },
        { id: 2, name: 'Car Types', route: '/transportation/overview/car-types' },
        { id: 3, name: 'Person Categories', route: '/transportation/overview/person-categories' },
        { id: 4, name: 'Cabins', route: '/transportation/overview/cabins' },
        { id: 5, name: 'Extras', route: '/transportation/overview/extras' },
        { id: 6, name: 'Prices', route: '/transportation/overview/prices' },
      ],
    };
  },
  methods: {
    ...mapActions({
      loadSuppliers: 'transportation/suppliersLoad',
      clearState: 'transportation/clearState',
    }),
  },
  computed: {
    ...mapState({
      suppliers: state => state.transportation.suppliers.items,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('menu.transportation.title'), to: '', disabled: true },
        { text: this.$t('menu.transportation.pages.overview.title'), to: '', disabled: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ];
    },
  },
  mounted() {
    if (!this.suppliers.length) {
      this.loadSuppliers();
    }
  },
  destroyed() {
    this.clearState();
  },
};
</script>

<template>
  <v-content>
    <tw-title-bar
      :title="$t('menu.transportation.pages.overview.title')"
      :breadcrumbs="breadcrumbs"
    />

    <v-container>
      <v-layout row>
        <v-flex xs12>
          <v-card>
            <v-tabs
              v-model="activeTab"
              fixed-tabs
              dark
            >
              <v-tab
                v-for="tab in tabs"
                :key="tab.id"
                :to="tab.route">
                {{ tab.name }}
              </v-tab>
              <v-tabs-items>
                <v-tab-item
                  v-for="tab in tabs"
                  :transition="false"
                  :reverse-transition="false"
                  :key="tab.id"
                  :value="tab.route">
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
            <router-view></router-view>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/transportation/TransportationWrapper.vue